// Fiksni vzorčni datum prototipa (petek), da se teden, dogodki in roki ujemajo.
export const DEMO_DATE = '2026-10-09';
export const WEEK_START = '2026-10-05';
export const WEEK_END = '2026-10-11';
export const WEEK_ID = '2026-W41';
export const NEXT_WEEK_START = '2026-10-12';
